import React, { useContext } from "react";
import NumberFormat from "react-number-format";
import { AppContext } from "../App";

import "../css/product.css";
import Tags from "./Tags";
import Label from "./Label";
import ProductLabels from "./ProductLabels";

function Products({ products, category }) {
	const { setProduct, getTranslatedString, shop } = useContext(AppContext);

	const hasPricedMandatoryVariants = (product) => {
		return product.variants_categories.find((vc) => vc.has_price == 1 && vc.min > 0);
	};

	return (
		<div className="products">
			<h4 className="category-title">{getTranslatedString(category, "name")}</h4>
			<p className="category-description">{getTranslatedString(category, "description")}</p>
			{products &&
				products.map((product) => (
						<div key={product.id} className="product" onClick={() => setProduct(product)}>
							<div className="buttons-groups">
								{product.img && (
									<div className="img">
										<img src={product.img} alt={product.name} />
									</div>
								)}
								<div className="product-content">
									<div className="title">{getTranslatedString(product, "name")}</div>
									<Tags product={product} />
									<ProductLabels product={product} />
									<div className="description-line">
										<div
											className="description"
											dangerouslySetInnerHTML={{
												__html: getTranslatedString(product, "description"),
											}}
										/>
										<div className="price">
											{hasPricedMandatoryVariants(product) ? (
												<span className="info">
													<Label number={13} />
												</span>
											) : (
												""
											)}
											<NumberFormat
												value={product.price}
												displayType={"text"}
												thousandSeparator="."
												decimalSeparator=","
												suffix={shop.currency == "CHF" ? " CHF" : " €"}
												isNumericString={true}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
		</div>
	);
}

export default Products;
